import { text } from './text';
import { getDateOfBirthFromSsn } from '@gjensidige/gpf-js-utils/es6/validation/ssn';
import { Period } from '@gjensidige/gpf-js-utils/es6/time/Period';
import { LocalDate } from '@gjensidige/gpf-js-utils/es6/time/LocalDate';
import { Datakilde, Fondskategori, Risikoprofil, Spareformål, } from './types';
export const getProfilEnumName = (profil) => {
    switch (profil) {
        case Risikoprofil.TRYGG:
            return text.PROFIL.TRYGG.no;
        case Risikoprofil.BALANSERT:
            return text.PROFIL.BALANSERT.no;
        case Risikoprofil.OFFENSIV:
            return text.PROFIL.OFFENSIV.no;
        case Risikoprofil.ALDERSTILPASSET:
            return text.PROFIL.ALDERSTILPASSET.no;
    }
};
export const getProfilInfo = (profil) => {
    switch (profil) {
        case Risikoprofil.TRYGG:
            return text.PROFIL_UTVIDET.TRYGG.no;
        case Risikoprofil.BALANSERT:
            return text.PROFIL_UTVIDET.BALANSERT.no;
        case Risikoprofil.OFFENSIV:
            return text.PROFIL_UTVIDET.OFFENSIV.no;
        case Risikoprofil.ALDERSTILPASSET:
            return text.PROFIL_UTVIDET.ALDERSTILPASSET.no;
    }
};
export const getProfilPillText = (profil) => {
    switch (profil) {
        case Risikoprofil.TRYGG:
            return text.PROFIL_PILL.TRYGG.no;
        case Risikoprofil.BALANSERT:
            return text.PROFIL_PILL.BALANSERT.no;
        case Risikoprofil.OFFENSIV:
            return text.PROFIL_PILL.OFFENSIV.no;
        case Risikoprofil.ALDERSTILPASSET:
            return text.PROFIL_PILL.ALDERSTILPASSET.no;
    }
};
export const getSpareformålSummary = (spareformål) => {
    switch (spareformål) {
        case Spareformål.PENSJON:
            return text.FORM.SUMMARY.SPAREFORMÅL.OPTIONS.PENSJON.LABEL.no;
        case Spareformål.BARN_BARNEBARN:
            return text.FORM.SUMMARY.SPAREFORMÅL.OPTIONS.BARN_BARNEBARN.LABEL.no;
        case Spareformål.SPESIFIKT_MÅL:
            return text.FORM.SUMMARY.SPAREFORMÅL.OPTIONS.SPESIFIKT_MÅL.LABEL.no;
        case Spareformål.IKKE_SPESIFIKT_MÅL:
            return text.FORM.SUMMARY.SPAREFORMÅL.OPTIONS.IKKE_SPESIFIKT_MÅL.LABEL.no;
    }
};
export const getProfilBeskrivelse = (profil, porteføljedata) => {
    switch (profil) {
        case Risikoprofil.TRYGG:
            return text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.TRYGG.DESCRIPTION_AND_ALLOCATION(getFondskategoriFordeling(porteføljedata[profil])).no;
        case Risikoprofil.BALANSERT:
            return text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.BALANSERT.DESCRIPTION_AND_ALLOCATION(getFondskategoriFordeling(porteføljedata[profil])).no;
        case Risikoprofil.OFFENSIV:
            return text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.OFFENSIV.DESCRIPTION_AND_ALLOCATION(getFondskategoriFordeling(porteføljedata[profil])).no;
        case Risikoprofil.ALDERSTILPASSET:
            return text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.DESCRIPTION_AND_ALLOCATION().no;
    }
};
export const getCustomerAge = (ssn) => {
    const dob = getDateOfBirthFromSsn(ssn);
    return Period.between(dob, LocalDate.now()).years;
};
export const getFormPayload = (formState, sellerId, featureFlagState) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        skjema: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ sellerId, domainOrigin: document.domain }, formState.kontoopplysninger), formState.profildata), formState.customerData), formState.amountData), { kontonavn: formState.kontoopplysninger.kontonavn || undefined, profile: ((_a = formState.profildata) === null || _a === void 0 ? void 0 : _a.profile) || ((_b = formState.risikoanbefaling) === null || _b === void 0 ? void 0 : _b.anbefaling.risikoprofil), raadgivningRef: ((_c = formState.raadgivningData) === null || _c === void 0 ? void 0 : _c.ref) || '', barnetsAlderVedUttak: formState.barnetsAlderVedUttak, datakilde: featureFlagState.featureFlags && featureFlagState.featureFlags.opprettPrivatprodukterICoreSuite
                ? Datakilde.CORE_SUITE
                : Datakilde.F2100 }),
        raadgivning: {
            egnethetstest: {
                questions: flattenGroupedQuestions(((_e = (_d = formState.raadgivningData) === null || _d === void 0 ? void 0 : _d.egnethet) === null || _e === void 0 ? void 0 : _e.groups) || []),
                answers: ((_g = (_f = formState.raadgivningData) === null || _f === void 0 ? void 0 : _f.egnethet) === null || _g === void 0 ? void 0 : _g.answers) || [],
                anbefaltProfil: (_h = formState.risikoanbefaling) === null || _h === void 0 ? void 0 : _h.anbefaling.risikoprofil,
            },
            fatca: {
                questions: flattenGroupedQuestions(((_k = (_j = formState.raadgivningData) === null || _j === void 0 ? void 0 : _j.fatca) === null || _k === void 0 ? void 0 : _k.groups) || []),
                answers: ((_m = (_l = formState.raadgivningData) === null || _l === void 0 ? void 0 : _l.fatca) === null || _m === void 0 ? void 0 : _m.answers) || [],
            },
        },
    };
};
export const getAuthenticationUrl = () => `/gpf-fkl/id?targetUrl=${window.location.pathname}`;
export const getFondskategoriFordeling = (portefølje) => {
    var _a, _b;
    const kategorifordeling = portefølje === null || portefølje === void 0 ? void 0 : portefølje.kategorifordeling;
    return {
        aksjeandel: (_a = kategorifordeling === null || kategorifordeling === void 0 ? void 0 : kategorifordeling.find((fordeling) => fordeling.fondskategori === Fondskategori.AKSJEFOND)) === null || _a === void 0 ? void 0 : _a.allokering,
        renteandel: (_b = kategorifordeling === null || kategorifordeling === void 0 ? void 0 : kategorifordeling.find((fordeling) => fordeling.fondskategori === Fondskategori.RENTEFOND)) === null || _b === void 0 ? void 0 : _b.allokering,
    };
};
export const flattenGroupedQuestions = (groups) => {
    return groups.flatMap((group) => group.questions);
};
export const hasAllCustomerData = (formState) => !!formState.customerData.ssn &&
    !!formState.customerData.firstName &&
    !!formState.customerData.surname &&
    !!formState.customerData.email;
